var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "newspaper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.4,
    viewBox: "0 0 24 18.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9617",
    "data-name": "Path 9617",
    d: "M4.725,5.063v15.8a1,1,0,0,1-2,0V9.063h-1.6v11.8a2.6,2.6,0,0,0,2.6,2.6h18.8a2.6,2.6,0,0,0,2.6-2.6V5.063Zm18.8,15.8a1,1,0,0,1-1,1H6.125a2.586,2.586,0,0,0,.2-1V6.663h17.2Z",
    transform: "translate(-1.125 -5.063)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9618",
    "data-name": "Path 9618",
    d: "M17.888,9.563h-7.2v8h7.2Zm-1.6,6.4h-4v-4.8h4Z",
    transform: "translate(-3.888 -6.363)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9619",
    "data-name": "Path 9619",
    d: "M23.063,9.563h5.2v1.6h-5.2Z",
    transform: "translate(-7.463 -6.363)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9620",
    "data-name": "Path 9620",
    d: "M23.063,14.063h5.2v1.6h-5.2Z",
    transform: "translate(-7.463 -7.663)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9621",
    "data-name": "Path 9621",
    d: "M23.063,18.563h5.2v1.6h-5.2Z",
    transform: "translate(-7.463 -8.963)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.683e4b26e26423ff1865ca2da9bdaf6e.svg";
export { ForwardRef as ReactComponent };